import React from "react";
import { CtaButton } from "../CtaButton";
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from "lucide-react";
const PORTADA = "https://cdn.magicpatterns.com/uploads/qs1ryXk2yTV2E1wM2RY7UX/PORTADA.png";
export function Hero() {
  return <header className="relative w-full bg-black overflow-hidden" data-id="element-122" data-mp="cujm2fp5lq1t">
      {/* radial glow */}
      <div className="absolute inset-0 opacity-60" style={{
      background: "radial-gradient(circle at 50% 20%, rgba(225,6,0,0.25), transparent 55%)"
    }} aria-hidden="true" data-id="element-123" data-mp="hw8vjqwq9vns" />
      <div className="relative max-w-6xl mx-auto px-4 pt-10 pb-6 sm:pt-16 text-center" data-id="element-124" data-mp="vmcarxx6wp3q">
        <span className="inline-block font-condensed tracking-[0.2em] text-[#e10600] text-lg sm:text-xl mb-3" data-id="element-125" data-mp="voot4c6v11hb">
          🍕 MEGAPACK 72HS™
        </span>

        <h1 className="font-display text-5xl sm:text-7xl md:text-8xl text-white uppercase leading-[0.85]" data-id="element-126" data-mp="15ltggfcfz2zp">
          Tu negocio de comidas.
          <br data-id="element-127" data-mp="1ah8r6yf5kirw" />
          <span className="text-[#e10600]" data-id="element-128" data-mp="9nswfo0ko1cm">Listo. Hoy.</span>
        </h1>

        <p className="font-condensed text-xl sm:text-2xl text-neutral-300 mt-5 tracking-wide max-w-3xl mx-auto" data-id="element-129" data-mp="9lq1cpkkbi11">
          El sistema N°1 para emprender desde la cocina en Argentina — Pizza · Pasta ·
          Pastelería · Sin TACC · Ghost Kitchen · Finanzas
        </p>

        <img src={PORTADA} alt="Megapack 72HS — Combo completo de 6 tomos: Maestro Pizzero, Pastelería, Pasta Gourmet, Recetario Exclusivo, Sin Gluten y Finanzas" className="w-full max-w-4xl mx-auto my-8 drop-shadow-2xl" data-id="element-130" data-mp="3ruqsp4sel1pk" />

        <p className="text-neutral-400 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed" data-id="element-131" data-mp="inz9j8scyzb9">
          Recetas + sistema de ventas + finanzas + organización listos para aplicar.
          <span className="text-white font-semibold" data-id="element-132" data-mp="1b4s2aotr7jy8"> Sin buscar. Sin improvisar. Sin perder más tiempo.</span>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-5 text-sm text-neutral-300" data-id="element-133" data-mp="16djt9twc60ll">
          <span data-id="element-134" data-mp="30mys6ofbzfj6">📄 100% PDF</span>
          <span data-id="element-135" data-mp="30mp81hgyw2le">⚡ Acceso en 5 min</span>
          <span data-id="element-136" data-mp="35ljs0mqo7x73">🇦🇷 Mercado argentino</span>
          <span data-id="element-137" data-mp="35kh4mosk4cvx">🍕 6 rubros completos</span>
        </div>

        <div className="max-w-md mx-auto mt-8" data-id="element-138" data-mp="2qwnon2zk78ct">
          <CtaButton pulse data-id="element-139" data-mp="2qvud7opnnuoc">🍕 Quiero mi Megapack 72HS ahora</CtaButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-4 text-xs sm:text-sm text-neutral-400" data-id="element-140" data-mp="2vtmevag3qv5q">
          <span className="flex items-center gap-1.5" data-id="element-141" data-mp="2hxim7lkvmuvd"><ShieldCheckIcon className="w-4 h-4 text-[#e10600]" data-id="element-142" data-mp="2musmjw9t0qxz" /> Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-143" data-mp="27xrtnpfvmpxx"><LockIcon className="w-4 h-4 text-[#e10600]" data-id="element-144" data-mp="27yt720kd7oit" /> Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-145" data-mp="2cxe79zzma879"><CreditCardIcon className="w-4 h-4 text-[#e10600]" data-id="element-146" data-mp="2cyfkob43v6s5" /> Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>

      {/* stats bar */}
      <div className="relative border-y border-neutral-800 bg-neutral-950" data-id="element-147" data-mp="b3x2r56s9ngq">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-neutral-800" data-id="element-148" data-mp="1vmhacgxodcm0">
          {[{
          v: "+300",
          l: "emprendedores activos"
        }, {
          v: "6",
          l: "Tomos listos"
        }, {
          v: "6",
          l: "Bonos incluidos"
        }, {
          v: "⭐ 4.9/5",
          l: "valoración"
        }].map(s => <div key={s.l} className="text-center py-5 px-2" data-id="element-149" data-mp="20kitt2z0jdy0">
              <div className="font-display text-3xl text-[#e10600]" data-id="element-150" data-mp="2ecyzycn7ns35">{s.v}</div>
              <div className="text-xs text-neutral-400 uppercase tracking-wide mt-1" data-id="element-151" data-mp="2abwydp5tn3y0">{s.l}</div>
            </div>)}
        </div>
      </div>
    </header>;
}